<template>
  <div class="container documents">
    <breadcrumb crumb="documents" />
    <el-row :gutter="24">
      <el-col :span="18">
        <div class="my_container-card">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="my_container-card-title">
                Выберите тип документа:
              </span>
            </div>
            <section class="doc-section">
              <el-row :gutter="18">
                <div
                  v-for="item in list"
                  :key="item.prop"
                  class="document-item"
                  @click="command(item.func, item.prop)"
                >
                  - {{ item.title }}
                </div>
              </el-row>
            </section>
          </el-card>
        </div>
      </el-col>
      <el-col :span="6">
        <hint />
      </el-col>
    </el-row>
    <adding-payment-modal
      :visible="dialogVisible"
      :result="resultPayDoc"
      @true="resultPayDoc = true"
      @false="resultPayDoc = false"
      @close="dialogVisible = false"
    />
    <over-akts-vis-modal
      :visible="overAktsVis"
      :result="resultPayDoc"
      @close="overAktsVis = false"
    />
    <upload-doc-modal
      :visible="doImportPayBank"
      @close="doImportPayBank = false"
    />
    <dialog-report-hartia :visible="isPeriod" @close="isPeriod = false" />
    <dialog-report-szvn :visible="isSzvnOpen" @close="isSzvnOpen = false" />
    <save-nomenclature :visible="saveNomModal" @close="saveNomModal = false" />
  </div>
</template>

<script>
import { documentsList } from '@/views/Documents/constants'
import AddingPaymentModal from '@/views/Documents/components/AddingPaymentModal'
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb'
import DialogReportHartia from '@/views/Documents/components/DialogReportHartia'
import DialogReportSzvn from '@/views/Documents/components/DialogReportSzvn'
import Hint from '@/components/Hints/Hint'
import OverAktsVisModal from '@/views/Documents/components/OverAktsVisModal'
import SaveNomenclature from '@/views/Documents/components/SaveNomenclature'
import UploadDocModal from './components/UploadDocModal'

export default {
  name: 'Documents',
  components: {
    Hint,
    SaveNomenclature,
    DialogReportHartia,
    DialogReportSzvn,
    OverAktsVisModal,
    AddingPaymentModal,
    UploadDocModal,
    Breadcrumb,
  },
  data() {
    return {
      isPeriod: false,
      dialogVisible: false,
      overAktsVis: false,
      doImportPayBank: false,
      saveNomModal: false,
      resultPayDoc: false,
      isSzvnOpen: false,
    }
  },
  computed: {
    list() {
      return documentsList.filter(item =>
        item.action ? this.canAction(item.action) : true,
      )
    },
  },
  methods: {
    command(func, val) {
      this[func](val)
    },
    openModal(key) {
      this[key] = true
    },
    goTo(name) {
      this.$router.push({ name })
    },
    todayResponses() {
      const baseURL =
        process.env.NODE_ENV === 'production'
          ? process.env.VUE_APP_API_URL_PROD
          : process.env.VUE_APP_API_URL
      const token = localStorage.getItem('auth-token')
      const link = document.createElement('a')

      link.href = `${baseURL}excel-builder/template/today-responses?bearer-token=${token}`
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
    tomorrowResponses() {
      const baseURL =
        process.env.NODE_ENV === 'production'
          ? process.env.VUE_APP_API_URL_PROD
          : process.env.VUE_APP_API_URL
      const token = localStorage.getItem('auth-token')
      const link = document.createElement('a')

      link.href = `${baseURL}excel-builder/template/tomorrow-responses?bearer-token=${token}`
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
    withoutTtn() {
      const link = document.createElement('a')

      link.href = `https://port-tranzit.ru/apiexp/ttns?token=729ed0986372807c7f0376df94f7425cba26b8a8`
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
    showSDIZes() {
      const link = document.createElement('a')

      link.href = `https://port-tranzit.ru/apiexp/sdiz?token=729ed0986372807c7f0376df94f7425cba26b8a8`
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
  },
}
</script>

<style lang="sass">
.payment-adding-form
  .el-dialog__body
    padding-top: 10px
.documents
  .my_container-card
    margin-bottom: 30px
  .my_container-card-title
    display: block
  .doc-section
    padding: 0 30px 40px
  .document-item
    font-size: 20px
    line-height: 24px
    margin: 10px 0 30px
    color: #3498DB
    cursor: pointer
</style>
